const GLOBAL_STORE_KEY = "__cartStore";
export const getGlobalStore = () => window[GLOBAL_STORE_KEY];
export const setGlobalStore = (store) => {
    window[GLOBAL_STORE_KEY] = store;
};
//# sourceMappingURL=globalStore.js.map